/**
 * Whether a nav entry owns the current pathname, and so should be highlighted.
 *
 * Detail routes carry a record id (`/matter/245`), so the section a menu entry can claim is the
 * last non-numeric segment. `altActiveUrls` covers the routes a list entry owns but is not named
 * after — a singular detail route, or a section whose plural is not the list url.
 *
 * Collapse groups without a url of their own depend on `altActiveUrls` entirely: their children are
 * unmounted while the group is collapsed, so no child effect is around to claim the route for them.
 */
export const matchesNavPathname = (pathname: string, url?: string, altActiveUrls?: string[]): boolean => {
    const itemPathname = url?.split('?')[0];
    const section =
        pathname
            .split('/')
            .filter((segment) => isNaN(Number(segment)))
            .pop() ?? '';

    return (
        pathname === itemPathname ||
        `/${section}s` === itemPathname ||
        (altActiveUrls?.includes(`/${section}`) ?? false)
    );
};
